import { Injectable } from '@angular/core';
import { AppService } from './app.service';
import { HttpClient } from '@angular/common/http';
import { Observable } from 'rxjs';
import { ApiResponse } from '../interfaces/api-response';
import { Order } from '../interfaces/order';


@Injectable({
	providedIn: 'root'
})
export class OrderService {

	constructor(
		private http: HttpClient,
		private app: AppService,
	) { }


	public getOrders(): Observable<ApiResponse> {
		return this.http.post(this.app.getApiEndpoint() + '/oauth/get-role-orders', {});
	}


	public cancelOrder(orderNumber: string): Observable<ApiResponse> {
		return this.http.post(this.app.getApiEndpoint() + '/oauth/cancel-user-order', { 'order_number': orderNumber });
	}


	public getOrderStatuses(orders: Order[]) {
		const uniqueStatuses = Array.from(new Set(orders.map(order => order.order_status)));
		uniqueStatuses.sort((a, b) => a.localeCompare(b));
		return uniqueStatuses;
	}

	
	public searchOrder(order: any, searchText: string): boolean {
		const searchRecursive = (obj: any): boolean => {
			return Object.values(obj).some(value => {
				if (typeof value === 'object' && value !== null) {
					return searchRecursive(value);
				}
				return value !== null && value.toString().toLowerCase().includes(searchText);
			});
		};
		return searchRecursive(order);
	}

}
